import { HelpersService } from '../../services/tools/helpers.service';
import { ValidatorService } from '../../services/tools/validator.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmModalComponent } from '../../components/tools/modals/confirm-modal/confirm-modal.component';
import { Globals } from '../../services/tools/Globals.service';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ConfiguracionCreditosService } from "../../services/configuracion-creditos.service";
import { AutenticacionService } from './../../services/autenticacion.service';
declare var $;


@Component({
  selector: 'app-configurar-creditos',
  templateUrl: './configurar-creditos.component.html',
  styleUrls: ['./configurar-creditos.component.scss'],
  providers: [NgbDropdownConfig]
})
export class ConfiguracionCreditosComponent implements OnInit {

  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;

  idConfiguracion : any = 1;
  periodo : any = [];
  anios : any = [];
  plazos : any = [];
  aniosSelected : any = {};
  plazosSelected : any = {};
  selected : any = [];
  object:any = [];
  indexSelected : any = 0;

  mostrarListado:boolean = true;
  errors:any = {};
  processing:any = false;

  constructor(private Service: ConfiguracionCreditosService, 
    private validatorService: ValidatorService, 
    private helperService: HelpersService,
    private globals: Globals, 
    config: NgbDropdownConfig,
    private authService: AutenticacionService,
    private router: Router){

    //Validate user has permission to use this view
    this.checkUserPermission();

    // se colocó esto para que el this dentro de delete sea el del scope global
    this.get();
    this.resetSelected = this.resetSelected.bind(this);
    config.placement = 'bottom-right';
  }

  private checkUserPermission(){
    if(!this.authService.isAdmin()){
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.startSelected();
    this.get();
    this.globals.passwordActivate = false;
    this.object = this.Service.getDefaultScheduleArray();
    this.selected = this.Service.getDefaultSchedule();
  }

  setTipo(id){
    this.idConfiguracion = id;
    this.indexSelected = this.object.findIndex(res => res.id === this.idConfiguracion);
    if(this.object[this.indexSelected].configuracion_creditos === null){
      this.object[this.indexSelected].configuracion_creditos = new Object(); // "object constructor" syntax
      this.object[this.indexSelected].configuracion_creditos.value = "";
    }
  }

  resetSelected(){
    this.anios = [];
    this.plazos = [];

    this.selected = undefined;
    this.errors = {};
  }

  startSelected(){
    this.resetSelected();
    for (var i = 1; i < 100; i++) {
      this.anios.push({"id" : i, "nombre": i});
    }
    this.plazos = [ {"id" : 1, "nombre": "meses"}, {"id" : 2, "nombre": "años"} ];

    this.selected = this.Service.getDefaultSchedule();
    this.aniosSelected = {"id" : 1, "nombre" : 1};
    this.plazosSelected = {"id" : 1, "nombre" : "meses"};
    this.indexSelected = 0;
  }
  
  get(){
    this.Service.get(false).subscribe(
      (response)=> 
      {
        this.object = response.json().content;
        this.indexSelected = this.object.findIndex(res => res.id === this.idConfiguracion);
        if(this.object[this.indexSelected].configuracion_creditos === null){
          this.object[this.indexSelected].configuracion_creditos = new Object(); // "object constructor" syntax
          this.object[this.indexSelected].configuracion_creditos.value = "";
        }
      }, error => {
        this.processing = false;

        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
    });
  }

  savePlazo(){
    this.errors = [];
    this.errors = this.Service.validatePlazos(this.aniosSelected.nombre, this.plazosSelected.nombre);
    if (!$.isEmptyObject(this.errors)) {
      return false;
    }

    this.object[this.indexSelected].catalogos_plazos.push({ "eliminado" : 0, "periodo" : this.aniosSelected.nombre, "medida" : this.plazosSelected.nombre, "activo" : 1, "idTipos_Creditos" : this.idConfiguracion });
  }

  removePlazo(index){
    this.object[this.indexSelected].catalogos_plazos[index].eliminado = 1;
  }

  changeCheckbox(index){
    this.object[this.indexSelected].catalogos_plazos[index].activo = 0;
  }

  update(){
    this.errors = [];
    this.errors = this.Service.validate(this.object[this.indexSelected]);
    if (!$.isEmptyObject(this.errors)) {
      return false;
    }
    this.Service.update(this.object[this.indexSelected], this.object[this.indexSelected].id)
      .subscribe(response => {
        this.processing = false;
        if (response.json().success) {
          this.helperService.notification('Configuración actualizada', 'Se ha actualizado exitosamente la configuración', 'success'); 
          
        }
      }, error => {
        this.processing = false;

          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);

          if(error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
      });
  }
  
  changeAniosSelected(anios){
    this.aniosSelected = anios;
  }

  changePlazosSelected(plazos){
    this.plazosSelected = plazos;
  }

  select(usuario){
    this.resetSelected();
    const Cloned = JSON.parse(JSON.stringify( usuario ));
    this.selected = Cloned;
  }

  setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  selectedWithId(){
    if(! this.selected)
      return false;

    return (this.validatorService.required(this.selected.id));
  }

  cancelarSelected() {
    this.confirmModal.open({
      'title': 'Cancelar Cambios',
      'description': '¿Está seguro que desea cancelar estos cambios?',
      'callback': this.resetSelected
    });
  }

  writePermission() {
    return this.Service.writePermission();
  }

  // MODAL FUNCTIONS
  modalCallback(callback){
    callback();
  }

  // MAIN SECTIONS FUNCTIONS 
  mainContainerClass(){
    return (this.mostrarListado)?"col-12":"offset-2 col-8";
  }

  mainTableClass(){
    return (this.mostrarListado)?"col-8":"col-4";
  }
}



// WEBPACK FOOTER //
// ./src/app/administracion/configurar-creditos/configurar-creditos.component.ts